import React from "react";
import { Formik, Form, Field } from "formik";
import { ApiService } from "../../../../services/ApiService";

export default function CreateassetCategoriesModal({
  closeModal,
  alert,
  getAllAssets,
}) {
  return (
    <React.Fragment>
      <Formik
        initialValues={{ name: "" }}
        onSubmit={(values) => {
          ApiService.post("assets/create-asset-category", values).then(
            (res) => {
              if (res.data.type === false) {
                alert.error(res.data.msg);
              } else if (res.data.type === true) {
                alert.success(res.data.msg);
              }
              getAllAssets();
              closeModal();
            }
          );
        }}
      >
        {({ handleSubmit, values, isSubmitting }) => (
          <Form>
            <div className="form-group">
              <label for="name">
                Name of category <span className="text-danger">*</span>
              </label>
              <Field
                type="text"
                className="form-control item"
                name="name"
                placeholder="Software, Hardware, Stationary"
                required
              />
            </div>
            <div className="form-group row">
              <div className="col">
                <button
                  type="button"
                  className="btn btn-danger btn-sm"
                  onClick={closeModal}
                >
                  Close
                </button>
              </div>
              <div className="col-md-10">
                <button
                  type="submit"
                  className="btn btn-block nt-button-color-default btn-sm"
                >
                  Save{" "}
                  {isSubmitting ? (
                    <span
                      id="login_spinner"
                      className="fa fa-spin fa-spinner"
                    ></span>
                  ) : null}
                </button>
              </div>
            </div>
          </Form>
        )}
      </Formik>
    </React.Fragment>
  );
}



// WEBPACK FOOTER //
// ./src/container/dashboard/organizationmanagement/modal/create_asset_categories.js